import styles from './styles.module.css'
import Popover from '../index'

const PopoverWithLink = ({ info, children }) => {
  return (
    <div className={styles.popoverRow}>
      {children}
      <Popover info={info} />
    </div>
  )
}

export default PopoverWithLink
